import Vue from 'vue';

export function fixWidth(value: any, width: number): string {
  let precision = width - value.toString().split('.')[0].length;
  if (precision < 0) {
    precision = 0;
  }
  return Number.parseFloat(value).toFixed(precision);
}
